import React, { useState } from "react";
import { categories as initialCategories } from "../../../misc/constants";
import CategoryCard from "../CategoryCard/CategoryCard";
import CategoryModal from "../CategoryModal/CategoryModal";
import { useUniversalFind } from "../../../hooks/universal";
import { useHookstate } from "@hookstate/core";
import { SocialCategory } from "../../../types";
import { useGlobalMiscState } from "../../../stores/misc";
import { sortById, updateMiscState } from "../../../misc/utils";
import AddItemModal from "../CategoryCard/AddItemModal";

type Props = {
  searchQuery: string;
};

export default function CategoriesTable({
  searchQuery,
}: Props) {
  const miscState = useGlobalMiscState();
  const socialTranscriptIsAddModalOpen = Boolean(miscState.get('socialTranscriptIsAddModalOpen'))
  const socialTranscriptIsAddSubcategoryModalOpen = Boolean(miscState.get('socialTranscriptIsAddSubcategoryModalOpen'))
  const socialTranscriptTriggerFetch = miscState.get('socialTranscriptTriggerFetch') || 0;
  const allSocialCategories: SocialCategory[] = useUniversalFind('SocialCategory', {}, {
    include: [
      {
        model: 'SocialSubcategory',
        as: 'subcategories',
        include: ['transcript_items']
      }
    ]
  }, socialTranscriptTriggerFetch);
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const openedCategory = state.openedCategory || "";

  const updateLocalValueRaw = (key: string) => (value: any) => {
    localState.merge({
      [key]: value,
    });
  };

  const socialCategories = allSocialCategories
    .filter(category => {
      const categoryMatches = category.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const itemsMatches = category.subcategories.some((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase()) || item.description?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      return categoryMatches || itemsMatches;
    })
    .sort(sortById)

  return (
    <div className="bg-[white] rounded-xl p-2">
      {socialCategories.map((category) => (
        <CategoryCard
          category={category}
          key={category.id}
          openedCategory={openedCategory}
          setOpenedCategory={updateLocalValueRaw('openedCategory')}
        />
      ))}
      {socialTranscriptIsAddModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
          <CategoryModal
            setIsAddCategoryModalOpen={updateMiscState('socialTranscriptIsAddModalOpen')}
          />
        </div>
      )}
      {socialTranscriptIsAddSubcategoryModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
          <AddItemModal />
        </div>
      )}
    </div>
  );
}
